<ng-container *ngIf="fit === 'natural'; else backgroundMode">
    <img class="natural-image" [src]="image | safeSrc" />
</ng-container>

<ng-template #backgroundMode>
    @if(showLogo){
        <svg-icon class="svg" src="assets/logo/logo.svg"></svg-icon>
    }
    <div *ngIf="icon" [style.background-color]="iconBackground" class="svg">
        <i class="{{icon}}"></i>
    </div>
    <div [style.background-image]="thumb | safeBgUrl" class="thumb" [class.fit-contain]="fit === 'contain'"></div>
    <div #imagediv
         [class.loaded]="base64"
         [class.fit-contain]="fit === 'contain'"
         [style.background-image]="(image || base64) | safeBgUrl"
         class="image"></div>
    <img (load)="imagediv.classList.add('loaded')" [src]="image | safeSrc"/>
</ng-template>

